import { ProgramCategoryEnum } from '../../uc-api-sdk';
import DisplayOrEmptyComponent from '../../uiComponent/DisplayComponent/DisplayOrEmptyComponent';
import { EmptyString } from '../../uiComponent/EmptyComponent/EmptyComponent';

export interface ProgramCategoryEnumComponentProps {
  value: ProgramCategoryEnum;
  type?: 'short' | 'long';
}

export const getProgramCategoryEnumShortText = (value?: ProgramCategoryEnum) => {
  switch (value) {
    case ProgramCategoryEnum.CCM: return 'CCM';
    case ProgramCategoryEnum.RPM: return 'RPM';
    case ProgramCategoryEnum.APCM: return 'APCM';
    case ProgramCategoryEnum.MEMBERSHIP: return 'Membership';
    case ProgramCategoryEnum.MNT: return 'MNT';
    case ProgramCategoryEnum.VALUE_BASED: return 'VBC';
    default: return EmptyString;
  }
};

export const ProgramCategoryEnumComponent = ({
  value,
  type = 'short',
}: ProgramCategoryEnumComponentProps) => {
  const getLongText = () => {
    switch (value) {
      case ProgramCategoryEnum.CCM: return 'Chronic Care Management (CCM)';
      case ProgramCategoryEnum.RPM: return 'Remote Patient Monitoring (RPM)';
      case ProgramCategoryEnum.APCM: return 'Advanced Primary Care Management (APCM)';
      case ProgramCategoryEnum.MEMBERSHIP: return 'Membership';
      case ProgramCategoryEnum.MNT: return 'Medical Nutrition Therapy (MNT)';
      case ProgramCategoryEnum.VALUE_BASED: return 'Value-based Care (VBC)';
      default: return <DisplayOrEmptyComponent />;
    }
  };

  const getText = () => {
    switch (type) {
      case 'long': return getLongText();
      case 'short':
      default: return getProgramCategoryEnumShortText(value);
    }
  };

  return (
    <span>{getText()}</span>
  );
};
